<template>
  <div>
    <b-form-checkbox
        v-model="groupBy"
        @change="groupByChange()"
        :value="true"
        :unchecked-value="false"
    >Показывать по дням</b-form-checkbox>
  </div>
</template>

<script>
import ACT from '../constants/vuexActions'
export default {
  name: 'GroupByDateFilter',
  props: {
    namespace: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      groupBy: false
    }
  },
  methods: {
    groupByChange () {
      this.$store.dispatch(`${this.namespace}/${ACT.GROUP_BY_DAY_UPDATED}`, !this.groupBy)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/GroupByDateFilter.vue